<header class="header">

  <div class="">

    <nav class="navbar">

      <!-- Logo -->
    
<a class="logo" routerLink="/">

  <div class="logo-icon">
   <img src="../../../../assets/images/icon/NeoHRMZ_Primary.svg" alt="Neohrmz">
  </div>

  <div class="logo-text">

    <span class="people">
      NeoHRMZ
    </span>

    <span class="hrms">
      HRMZ
    </span>

  </div>

</a>

      <!-- Navigation -->
      <ul class="nav-links">

        <li><a (click)="goTo('/')">Home</a></li>

        <li><a (click)="goTo('/all-features')">Features</a></li>

        <li><a (click)="goTo('/about-us-custom')">About Us</a></li>

        <!-- <li><a (click)="goTo('/solutions')">Solutions</a></li> -->

        <li><a (click)="goTo('/contact-custom-brand')">Contact Us</a></li>

        <li><a (click)="goTo('/products')">Pricing</a></li>

      </ul>
      <!-- Buttons -->

      <div class="header-actions">

        <button class="login-btn" (click)="goTo('/sign-in')">
          Login
        </button>

        <button class="demo-btn" (click)="goTo('/demo')">
          Book a Demo
        </button>

      </div>

    </nav>

  </div>

</header>